import type ErrorStatus from '../../../../types/errors/ErrorStatus';
import type { GenericErrorStatus } from '../../../../types/errors/ErrorStatus';
import type WarningStatus from '../../../../types/errors/WarningStatus';
import type { PartnerInfo } from '../urls/useUrlInfo';

interface LogErrorFields {
  pid: PartnerInfo['pid'];
  requestId: PartnerInfo['requestId'];
  [key: string]: string;
}

const useLog = () => {
  return {
    actions: {
      logError: (type: ErrorStatus | GenericErrorStatus, { pid, requestId, ...otherFields }: LogErrorFields) => {
        const includeOtherFields =
          Object.keys(otherFields).length > 0 ? `details: ${JSON.stringify(otherFields)}` : 'details: {}';
        console.error(`${type} --> pid: ${pid} requestId: ${requestId} ${includeOtherFields}`);
      },
      logWarn: (type: WarningStatus, message: string, logPrefix?: string) => {
        console.warn(logPrefix ? `[${logPrefix}] ${type} --> ${message}` : `${type} --> ${message}`);
      },
    },
  };
};

export default useLog;
